import {
  collection,
  getDocs,
  limit,
  query,
  where,
} from 'firebase/firestore';

function createdAtMs(data) {
  const c = data?.createdAt;
  const d = c?.toDate?.() ?? (c instanceof Date ? c : null);
  return d && typeof d.getTime === 'function' ? d.getTime() : 0;
}

/**
 * Map a posted sponsored date idea Firestore doc into a carousel card shape.
 */
export function mapPostedSponsoredDateIdea(docSnap) {
  const d = docSnap.data() ?? {};
  const selectedPlace = d.selectedPlace && typeof d.selectedPlace === 'object' ? d.selectedPlace : null;
  return {
    id: docSnap.id,
    place: typeof d.place === 'string' ? d.place.trim() : '',
    location: typeof d.location === 'string' ? d.location.trim() : (typeof d.place === 'string' ? d.place.trim() : ''),
    whatToGetOrDo: typeof d.whatToGetOrDo === 'string' ? d.whatToGetOrDo.trim() : '',
    highlights: typeof d.highlights === 'string' ? d.highlights.trim() : '',
    imageStorageUrl: selectedPlace?.imageStorageUrl ?? null,
    imageUrl: selectedPlace?.imageUrl ?? null,
    createdAt: d.createdAt ?? null,
  };
}

/**
 * Load up to 5 Fox-Paid date ideas with `posted === true` for the home carousel.
 */
export async function fetchPostedSponsoredDateIdeas(firestore) {
  const q = query(
    collection(firestore, 'sponsoredDateIdeaSubmissions'),
    where('posted', '==', true),
    limit(25),
  );
  let snap;
  try {
    snap = await getDocs(q);
  } catch (err) {
    console.error('sponsoredDateIdeaSubmissions posted query failed (deploy firestore rules):', err);
    return [];
  }

  return snap.docs
    .slice()
    .sort((a, b) => createdAtMs(b.data()) - createdAtMs(a.data()))
    .slice(0, 5)
    .map(mapPostedSponsoredDateIdea)
    .filter((item) => item.place);
}
